// Botón "Filtros" con contador de filtros activos, para reemplazar el card de filtros
// siempre-visible en mobile (ver style/mobile.css .mob-boton-filtros). Abre un BottomSheet
// con los mismos controles de filtro que ya existen en la pantalla — no duplica su estado.
export default function BotonFiltros({ cantidad = 0, onClick }) {
    return (
        <button type="button" className="mob-boton-filtros mob-tocable" onClick={onClick}>
            <i className="bi bi-funnel" aria-hidden="true" />
            Filtros
            {cantidad > 0 && <span className="mob-boton-filtros-badge">{cantidad}</span>}
        </button>
    );
}
